"use client";

import { useEffect, useState } from "react";
import { Instagram, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        <li className="h-5 w-24 bg-foreground/10 animate-pulse rounded-md" />
        <li className="h-5 w-20 bg-foreground/10 animate-pulse rounded-md" />
        <li className="h-5 w-28 bg-foreground/10 animate-pulse rounded-md" />
        <li className="h-5 w-24 bg-foreground/10 animate-pulse rounded-md" />
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li data-index={i} key={item.id}>
          <Link to={item.href || "#"} className="font-default text-[15px] text-foreground/85 hover:text-primary hover:underline underline-offset-4 transition-colors duration-300">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const shopLinks = [{
  label: "Summer Camp",
  href: "/OurRhythmPage"
}, {
  label: "Team Sports",
  href: "/OurRhythmPage"
}, {
  label: "Live Music",
  href: "/OurRhythmPage"
}, {
  label: "Social Events",
  href: "/OurRhythmPage"
}];
const connectLinks = [{
  label: "Parent Hub",
  href: "/ParentHubPage"
}, {
  label: "Volunteer",
  href: "/ParentHubPage"
}, {
  label: "Small Groups",
  href: "/OurRhythmPage"
}, {
  label: "Contact Us",
  href: "/ParentHubPage"
}];
const socials = [{
  name: "Instagram",
  href: "#",
  icon: Instagram
}, {
  name: "YouTube",
  href: "#",
  icon: Youtube
}];
function SeoulTime() {
  const [time, setTime] = useState<string>("");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      const formatter = new Intl.DateTimeFormat("en-GB", {
        timeZone: "UTC",
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
      });
      setTime(formatter.format(now));
    };
    updateTime();
    const interval = setInterval(updateTime, 30000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center gap-2">
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-lg bg-primary opacity-75"></span>
        <span className="relative inline-flex h-2 w-2 rounded-lg bg-primary"></span>
      </span>
      <span className="text-xs font-mono tracking-wide text-foreground/60">
        Local Time: {time || "--:--"}
      </span>
    </div>;
}
export default function Footer() {
  return <section data-section-id="4915" id="footer" className="bg-background text-foreground pt-[120px] pb-12 border-t border-border">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {}
        <div className="mb-16 md:mb-24">
          <h2 className="font-default font-black leading-[0.95] tracking-tighter text-foreground text-5xl sm:text-7xl md:text-8xl lg:text-[9rem] xl:text-[10rem]">
            Join the{" "}
            <em className="italic font-black text-primary">Tribe.</em>
          </h2>
        </div>

        {}
        <Separator className="bg-border mb-16" />

        {}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-10 mb-16">
          {}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <p className="font-default text-base text-foreground/75 leading-relaxed mb-8 max-w-xs">
              Youth Tribe is a dynamic community for the next generation. Building connections, faith, and memories together.
            </p>
            <div className="flex items-center gap-3">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.name} data-index={i} to={social.href} aria-label={social.name} newTab className="group flex items-center justify-center h-10 w-10 rounded-lg border border-border hover:border-primary hover:bg-primary/10 transition-all duration-300">
                    <Icon className="h-4 w-4 text-foreground/70 group-hover:text-primary transition-colors duration-300" strokeWidth={1.5} />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-6">
              Navigation
            </h3>
            <MenuProvider menu_id="3">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-6">
              Activities
            </h3>
            <ul className="space-y-3">
              {shopLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="font-default text-[15px] text-foreground/85 hover:text-primary hover:underline underline-offset-4 transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-mono text-xs uppercase tracking-[0.3em] text-primary mb-6">
              Connect
            </h3>
            <ul className="space-y-3">
              {connectLinks.map((link, i) => <li data-index={i} key={link.label}>
                  <Link to={link.href} className="font-default text-[15px] text-foreground/85 hover:text-primary hover:underline underline-offset-4 transition-colors duration-300">
                    {link.label}
                  </Link>
                </li>)}
            </ul>
            <div className="mt-8 space-y-2">
              <p className="font-default text-sm text-foreground/70">
                Community Center, City
              </p>
              <p className="font-default text-sm text-foreground/70">
                hello@youthtribe.org
              </p>
              <p className="font-default text-sm text-foreground/70">
                +1 (555) 000-0000
              </p>
            </div>
          </div>
        </div>

        {}
        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6">
            <p className="font-mono text-xs text-foreground/60 tracking-wide">© 2026 YOUTH TRIBE — Community Driven</p>
            <SeoulTime />
          </div>

          <div className="flex items-center gap-6">
            <div className="flex items-center gap-2">
              <span className="font-mono text-xs uppercase tracking-[0.15em] text-foreground/50">
                Language
              </span>
              <span className="font-mono text-xs text-foreground/80">EN</span>
            </div>

            <div className="flex items-center gap-2">
              <div className="h-6 w-9 rounded-lg border border-border flex items-center justify-center">
                <span className="font-mono text-[9px] font-semibold text-foreground/70 tracking-tight">
                  YTH
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}